export default __webpack_public_path__ + "static/PromptIconSix-fabbc6d7a0492ee500df111953e3fc14.png";